import type { WidgetProps } from '@rjsf/utils'
import { Mtds } from 'prove-common'

export const MultiSelectWidget = ({
  disabled,
  id,
  onChange,
  options: { enumOptions: options },
  placeholder,
  readonly,
  required,
  value
}: WidgetProps) => {
  const selectedValues = new Set(value.map(String))
  const selected = options
    ?.filter((o) => selectedValues.has(String(o.value)))
    .map(({ label, value }) => ({ label, value: `${value}` })) // Convert value to string for HTML compatibility

  return (
    <Mtds.Field.Suggestion
      data-multiple
      selected={selected}
      onSelectedChange={(items) => {
        const itemValues = new Set(items.map((item) => item.value))
        const optValues = options?.map((o) => o.value)
        onChange(optValues?.filter((value) => itemValues.has(`${value}`))) // Get original value format
      }}
    >
      <Mtds.Input
        disabled={disabled || readonly}
        id={id}
        placeholder={placeholder}
        required={required}
      />
      <button type='reset' aria-label='Fjern tekst' />
      <Mtds.Field.Datalist>
        {options?.map(({ label, value }) => (
          <Mtds.Field.Option key={value} value={value}>
            {label}
          </Mtds.Field.Option>
        ))}
      </Mtds.Field.Datalist>
    </Mtds.Field.Suggestion>
  )
}
